import React from "react";
import Text from "@amzn/meridian/text";

const WipSettingsTab: React.FC = () => (
  <Text>WIP Settings coming soon.</Text>
);

export default WipSettingsTab;
